import { render, staticRenderFns } from "./assetUpload.vue?vue&type=template&id=b3f90c9a&"
import script from "./assetUpload.vue?vue&type=script&lang=js&"
export * from "./assetUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports